const topics = [
  { id: 1, name: '明星恋情曝光', count: '326.5万', hot: true },
  { id: 2, name: '综艺吃瓜合集', count: '258.3万', hot: true },
  { id: 3, name: '网红翻车现场', count: '415.7万', hot: true },
  { id: 4, name: '娱乐圈大事件', count: '198.2万', hot: false },
  { id: 5, name: '黑料视频专区', count: '532.1万', hot: true },
  { id: 6, name: '品牌公关危机', count: '147.6万', hot: false },
  { id: 7, name: '影视幕后揭秘', count: '183.9万', hot: false },
  { id: 8, name: '音乐圈吃瓜', count: '126.4万', hot: false },
  { id: 9, name: '51黑料一区', count: '678.3万', hot: true },
  { id: 10, name: '51黑料二区', count: '592.8万', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            话题标签
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            探索51黑料网在线观看最热话题与讨论风向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-500 text-background-50 hover:bg-accent-600'
                  : 'bg-background-50 border border-background-200/70 text-foreground-700 hover:border-accent-300 hover:text-accent-700'
              }`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-sm"></i>
              )}
              <span>{topic.name}</span>
              <span
                className={`text-xs ${
                  topic.hot ? 'text-background-50/70' : 'text-foreground-500'
                }`}
              >
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}